<template>
  <Navbar title="Registrar pago" :class="{'show' : showNavbar}">
    <template v-slot:close>
      <div @click="$emit('close')" class="close">
        Cerrar
      </div>
    </template>
    <template v-slot:content>
      <template v-if="!data.paid">
        <!--Detail card-->
        <div class="expense-detail">
          <div class="expense-detail__amount">
            {{ Intl.NumberFormat('en-US', { style: 'currency', currency: data.currency ? data.currency.code : 'PEN' }).format(data.total) }}
          </div>
          <div class="expense-detail__grid">
            <div class="expense-detail__item" v-if="data.type">
              <span class="expense-detail__label">Tipo</span>
              <span class="expense-detail__value">{{ data.type }}</span>
            </div>
            <div class="expense-detail__item" v-if="data.local">
              <span class="expense-detail__label">Propiedad</span>
              <span class="expense-detail__value">{{ data.local.description }}</span>
            </div>
            <div class="expense-detail__item" v-if="data.deadline">
              <span class="expense-detail__label">Vencimiento</span>
              <span class="expense-detail__value">{{ moment(data.deadline).lang('es').format('DD[/]MMMM[/]YYYY') }}</span>
            </div>
            <div class="expense-detail__item" v-if="data.currency">
              <span class="expense-detail__label">Moneda</span>
              <span class="expense-detail__value">{{ data.currency.name || data.currency.code }}</span>
            </div>
          </div>
        </div>
        <!--Payment date-->
        <div class="form-group">
          <label for="paymentDate">Fecha de pago</label>
          <v-date-picker
            ref="paymentDate"
            id="paymentDate"
            name="paymentDate"
            v-model="document.paymentDate"
            color="red"
            is-expanded
            :timezone="`America/Lima`"
          />
          <span v-if="this.validationErrors.paymentDate" class="error">{{ this.validationErrors.paymentDate }}</span>
        </div>
        <!--Observation-->
        <div class="form-group">
          <label for="observation">Observación</label>
          <textarea v-model="document.observation" class="textarea" id="observation" rows="2" placeholder="Descripción del gasto o nota del pago"></textarea>
        </div>
        <!--Voucher-->
        <div class="form-group">
          <input @change="updateImage" class="file" ref="uploadVoucher" type="file" accept="image/*" multiple>
          <button class="btn btn--outline btn--w100" @click="$refs.uploadVoucher.click()">Adjuntar comprobantes</button>
          <div v-if="previews.length" class="previews">
            <div v-for="(img, index) in previews" :key="index" class="previews__item">
              <img :src="img" alt="Voucher">
              <span class="previews__remove" @click="removeImage(index)">&times;</span>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <!--Detail card-->
        <div class="expense-detail">
          <div class="expense-detail__amount expense-detail__amount--paid">
            {{ Intl.NumberFormat('en-US', { style: 'currency', currency: data.currency ? data.currency.code : 'PEN' }).format(data.total) }}
            <span class="expense-detail__badge">Pagado</span>
          </div>
          <div class="expense-detail__grid">
            <div class="expense-detail__item" v-if="data.type">
              <span class="expense-detail__label">Tipo</span>
              <span class="expense-detail__value">{{ data.type }}</span>
            </div>
            <div class="expense-detail__item" v-if="data.local">
              <span class="expense-detail__label">Propiedad</span>
              <span class="expense-detail__value">{{ data.local.description }}</span>
            </div>
            <div class="expense-detail__item">
              <span class="expense-detail__label">Fecha de pago</span>
              <span class="expense-detail__value">{{ moment(document.paymentDate).lang('es').format('DD[/]MMMM[/]YYYY') }}</span>
            </div>
            <div class="expense-detail__item" v-if="data.currency">
              <span class="expense-detail__label">Moneda</span>
              <span class="expense-detail__value">{{ data.currency.name || data.currency.code }}</span>
            </div>
          </div>
          <div class="expense-detail__obs" v-if="document.observation">
            <span class="expense-detail__label">Observación</span>
            <p>{{ document.observation }}</p>
          </div>
        </div>
        <!--Vouchers-->
        <div v-if="voucherList.length" class="media-grid">
          <div v-for="(img, index) in voucherList" :key="index" class="media">
            <img :src="img" alt="Voucher de pago">
            <div @click="openImg(img)" class="media__open">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-external-link">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                <polyline points="15 3 21 3 21 9"></polyline>
                <line x1="10" y1="14" x2="21" y2="3"></line>
              </svg>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-slot:footer>
      <button :disabled="progress || data.paid" :class="{'is-loading': progress}" @click="save" class="btn">
        <span v-if="!progress">Registrar pago</span>
      </button>
    </template>
  </Navbar>
  <Shadow :class="{'show' : showNavbar}"/>
</template>

<script>
import Navbar from '@/components/Navbar'
import Shadow from '@/components/Shadow'
import moment from 'moment'

import * as yup from 'yup'

import { FieldValue, db, storage } from '@/firebase/firebaseConfig'

yup.setLocale({
  mixed: {
    required: 'Este campo es obligatorio'
  },
  number: {
    positive: 'Debe ser positivo',
    integer: 'Debe ser entero',
    truncate: 'Formato incorrecto'
  }
})

export default {
  name: 'Pay',
  components: {
    Navbar,
    Shadow
  },
  props: {
    showNavbar: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    data: {
      type: Object,
      default: () => {
        return { client: { currency: { code: '' } } }
      }
    }
  },
  watch: {
    showNavbar (value) {
      if (value) {
        // La observación del gasto se arrastra al formulario: es el MISMO campo
        // que llena el alta, no una nota aparte del pago. Abriendo en blanco, el
        // guardado la sobrescribía con '' y la descripción se perdía sin aviso
        // — 41 gastos pagados quedaron sin ella, casi todos «Misceláneos», donde
        // era lo único que decía de qué se trataba.
        this.document = { observation: this.data.observation || '' }
        this.validationErrors = {}
        this.previews = []
        this.attachments = []
        if (this.data.paid) {
          this.document = {
            ...this.data
          }
        }
      }
    }
  },
  data () {
    return {
      document: {},
      progress: false,
      schema: yup.object().shape({
        paymentDate: yup.date().required().label('Fecha de pago')
      }),
      include: true,
      validationErrors: {},
      attachments: [],
      previews: [],
      moment: moment
    }
  },
  computed: {
    voucherList () {
      if (this.document.vouchers && this.document.vouchers.length) return this.document.vouchers
      if (this.document.voucher) return [this.document.voucher]
      return []
    }
  },
  methods: {
    /**
     * Save data in firestore
     * */
    async save () {
      try {
        this.progress = true
        this.validationErrors = {}
        await this.schema.validate({ ...this.document }, { abortEarly: false })
        const obj = {
          paymentDate: this.document.paymentDate,
          paid: true,
          updatedAt: FieldValue.serverTimestamp(),
          observation: this.document.observation || ''
        }
        // Sólo se toca `vouchers` si hay algo que adjuntar, y se suma a los que
        // ya estuvieran: escribirlo siempre en [] borraba los existentes.
        if (this.attachments.length) {
          const uploaded = await Promise.all(this.attachments.map(f => this.submitFile(f)))
          obj.vouchers = [...(this.data.vouchers || []), ...uploaded]
        }
        await db.collection('expenses').doc(this.data.id).update({
          ...obj
        })
        obj.id = this.data.id
        this.$emit('update', obj)
        this.$emit('close')
      } catch (err) {
        console.log(err)
        if (err.inner) {
          err.inner.forEach(error => {
            if (error.path) {
              this.validationErrors[error.path] = error.message
            }
          })
        } else {
          this.$toast.error('Error al registrar pago')
        }
      } finally {
        this.progress = false
      }
    },
    updateImage (input) {
      if (input.target.files) {
        Array.from(input.target.files).forEach(file => {
          this.attachments.push(file)
          const reader = new FileReader()
          reader.onload = e => {
            this.previews.push(e.target.result)
          }
          reader.readAsDataURL(file)
        })
        this.$refs.uploadVoucher.value = ''
      }
    },
    removeImage (index) {
      this.attachments.splice(index, 1)
      this.previews.splice(index, 1)
    },
    /**
     * Save doc in firebase storage
     * @param doc
     * @returns {Promise<unknown>}
     */
    submitFile (doc) {
      return new Promise((resolve, reject) => {
        const docName = Math.random().toString(36).substr(1, 20)
        const fileExtension = '.' + doc.name.split('.').pop()
        const docNameFinal = docName + fileExtension

        const storageRef = storage.ref(`vouchers/${docNameFinal}`)
        storageRef.put(doc)
          .then((snapshot) => {
            snapshot.ref.getDownloadURL().then((url) => {
              resolve(url)
            })
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    openImg (img) {
      window.open(img, '_blank')
    }
  }
}
</script>

<style scoped>
.expense-detail {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid #ebebeb;
}

.expense-detail__amount {
  font-family: 'Inter Display', 'Inter', sans-serif;
  font-size: 28px;
  font-weight: 500;
  color: #191919;
  letter-spacing: -0.02em;
  font-feature-settings: "tnum";
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.expense-detail__amount--paid {
  color: #3BB273;
}

.expense-detail__badge {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: #3BB273;
  color: white;
  padding: 3px 8px;
  border-radius: 20px;
}

.expense-detail__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding-top: 16px;
  border-top: 0.5px solid #ebebeb;
}

.expense-detail__item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.expense-detail__label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #8f8f8f;
}

.expense-detail__value {
  font-size: 13px;
  font-weight: 500;
  color: #191919;
}

.expense-detail__obs {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 0.5px solid #ebebeb;
}

.expense-detail__obs p {
  font-size: 13px;
  color: #707070;
  margin-top: 4px;
  line-height: 1.4;
}
</style>
